import { API } from '@config';
import { ContactUsGenerationAdministrationTable } from '@src/types/ContactUsGenerationAdministration';

export const getGenerationAdministration = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/contact-us-generation-administrations?populate=File&sort=id%3Adesc`, options);
  const data: ContactUsGenerationAdministrationTable = await response.json();

  return data;
};
